import React from "react";
import { SNavigation, SPage, SText, STheme } from "servisofts-component";
import { DinamicTable } from "servisofts-table";
import SSocket from "servisofts-socket";
import Model from "../../Model";
export default class racha_de_paquetes extends React.Component {
    state = {
        cantidad: 0
    }
    async loadData() {
        const resp = await SSocket.sendPromise({
            component: "reporte",
            type: "execute_function",
            func: "reporte_racha_de_paquetes",
            params: []
        })
        resp.data.map(a => {
            a.user = Model.usuario.Action.getByKey(a.key_usuario)
        })
        return resp.data
    }
    render() {
        return <SPage title={"racha_de_paquetes"}>
            <SText>{this.state.cantidad} Resultados</SText>
            <DinamicTable
                ref={ref => this.table = ref}
                language="es"
                loadData={this.loadData.bind(this)}
                cellStyle={{
                    borderWidth: 0,
                }}



                onEvent={e => {
                    if (this.table) {
                        if (this.table.dataFiltrada) {
                            if (this.state.cantidad != this.table.dataFiltrada.length) {
                                this.setState({ cantidad: this.table.dataFiltrada.length })
                            }
                        }
                    }

                }}
            >
                <DinamicTable.Col key={"key_usuario"} label="key_usuario" data={e => e.row.key_usuario}
                    textStyle={{
                        fontSize: 12,
                        color: STheme.color.lightGray
                    }}
                    onPress={(e) => {
                        SNavigation.navigate("registro", { key: e.row.key_usuario })
                    }}

                />
                <DinamicTable.Col key={"usuario_nombres"} label="Usuario" width={250} data={e => `${e.row?.user?.Nombres} ${e.row?.user?.Apellidos}`} />
                <DinamicTable.Col key={"total_consecutivos"} dataType="number" label="total_consecutivos" data={e => e.row.total_consecutivos} cellStyle={{
                    alignItems: "center"
                }} />
                <DinamicTable.Col key={"fecha_fin"} label="fecha_fin" data={e => e.row.fecha_fin} />
            </DinamicTable>
        </SPage>
    }
}


